import { useReducer } from 'react'
import { IRequestAction, IRequestState } from '../types'
import { initialRequestState, requestReducer } from '../utils'

type IReducerState = (state: IRequestState, action: IRequestAction) => IRequestState

export const useFilterAutocomplete = () => {
  const [reducerState, reducerDispatch] = useReducer<IReducerState>(
    requestReducer,
    initialRequestState
  )

  return {
    reducerState,
    reducerDispatch,
  }
}
